// Safe UUID generator with fallback for non-secure contexts / older environments
// where window.crypto.randomUUID may be undefined.
export function newRid() {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
        try { return crypto.randomUUID(); } catch { /* fall through */ }
    }
    return `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}
